/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';

export const useCurrencyConvertor = () => {
  const GET_CURRENCY_RATES = gql`
    query GetCurrencyRates {
      rates {
        fromCurrency
        currencyRates {
          toCurrencyDisplayName
          toCurrency
          currencyCountryCode
          currencyCountry
          currencyPlural
          conversionFactor
          popularCurrencyRanking
          toCurrencySymbol
        }
      }
    }
  `;
  const { loading, error, data,refetch } = useQuery(GET_CURRENCY_RATES,{context:{
    "clientName":"/currency"
  }});
  handleApolloError(__filename, error);

  return { error, loading, data: data ?? [], refetchExchangeRates: refetch };
};
